module.exports = __webpack_public_path__ + "static/media/50@2x.d891ef88.png";